import { createContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { responseInterceptor } from "../api/axios";

import axios from "../api/axios";
import config from '../config/config.json';

const AuthContext = createContext({});

export const AuthProvider = ({children}) => {

    const [auth, setAuth] = useState({});       
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/"; 
    const [working, setWorking] = useState(true);

    const refresh = async () => {
        
        setWorking(true);
        try {         
            const response = await axios.post('/api/auth/GetUserByCookie', {}, {
                withCredentials: true
            });

            if (response.status === 200) {
                setAuth({
                    uid: response.data.id,
                    ufn: response.data.userFirstname,
                    uln: response.data.userLastname,
                    uem: response.data.userEmail,
                    uia: response.data.isActive,
                    uri: response.data.roleId
                });    

                setWorking(false);    
                let navigateTo = window.location.href.replace(window.location.origin, '');                     
                console.log('nav to: ' + navigateTo);  
                navigate(navigateTo);
            } else {
                //setAuth({});
                //logoutUser();
                setWorking(false);
            }
        } catch (refreshError) {
            setWorking(false);
            console.log("Error refreshing authentication data:", refreshError);
            //setAuth({});
            //logoutUser();            
        }
        //return Promise.reject(error);
    };

    const logoutUser = () => {
        axios.post(config.endPoint + "/api/auth/LogOut", {}, {
            withCredentials: true
        })
        .then(() => {
            setWorking(true);
            navigate('/Login');
        })
        .catch((error) => {
            console.log(error);
        });
    };


    useEffect(() => {
        if (!auth.uid) {                       
            setWorking(true);
            axios.interceptors.response.eject(responseInterceptor);
            //console.log('auth.uid null so refresh... ');
            refresh();
        } else {
            //console.log('auth uid not null');
            return;
        }     
    },[]); 

    return (
        <AuthContext.Provider value={{ auth, setAuth }}>
            {!working ? children : null }
        </AuthContext.Provider>
    );
};

export default AuthContext;